(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

    // ── Floating Social Actions ──
    const trigger = document.getElementById('SocialTrigger');
    const pill = document.getElementById('SocialPill');
    if (trigger && pill) {
      trigger.addEventListener('click', (e) => { e.stopPropagation(); pill.classList.toggle('is-active'); });
      document.addEventListener('click', () => { if (pill) pill.classList.remove('is-active'); });
      pill.addEventListener('click', (e) => e.stopPropagation());
    }

    // ── Auto-inject Utilities Block into Drawer ──
    const menuDrawerInner = document.querySelector('.menu-drawer__inner-container');
    const drawerMenuList = document.querySelector('.menu-drawer__menu');

    if (menuDrawerInner && !document.querySelector('.eb-custom-blocks')) {
      const customBlocks = document.createElement('div');
      customBlocks.className = 'eb-custom-blocks';
      customBlocks.innerHTML = `
        <a href="/account" class="eb-track-order">
          <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
          <div class="eb-track-text">
            <strong>Track Order</strong>
            <span>Check Your Order Status</span>
          </div>
        </a>
        <div class="eb-shop-category">
          <strong>Shop By Category</strong>
        </div>
      `;
      menuDrawerInner.insertBefore(customBlocks, menuDrawerInner.firstChild);
    }

    // ── Add Shop By Brand link ──
    if (drawerMenuList && !document.querySelector('.eb-shop-brand-menu-item')) {
      const brandItem = document.createElement('li');
      brandItem.className = 'eb-shop-brand-menu-item';
      brandItem.innerHTML = `
        <a href="/pages/brand-directory" class="eb-shop-category eb-shop-brand-link">
          <strong>Shop By Brand </strong>
          <span class="eb-brand-arrow">→</span>
        </a>
      `;
      drawerMenuList.appendChild(brandItem);
    }

  });

  // ── Menu Item Icons ──
  // Keys must be LOWERCASE and match exactly what Shopify stores in the nav
  // (CSS capitalize makes them look titled but the raw value is lowercase)
  const MENU_ICONS = {
    'boat'        : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/boat.jpg?v=1779600053',
    'heli'        : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/heli.jpg?v=1779600053',
    'car'         : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/car.jpg?v=1779600054',
    'plane'       : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/plane.jpg?v=1779600053',
    'trains'      : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/trains.webp?v=1779600054',
    'models'      : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/models.jpg?v=1779600053',
    'slots'       : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/slots.webp?v=1779600054',
    'electronics' : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/electrics.jpg?v=1779600053',
    'equipment'   : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/equipment.jpg?v=1779600053',
    'accessories' : 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/accersory.jpg?v=1779600053',
  };

  const MENU_ICON_SIZE = 28;

  function injectMenuIcons() {
    const items = document.querySelectorAll(
      '.menu-drawer a.list-menu__item, .menu-drawer summary.list-menu__item'
    );
    items.forEach(item => {
      if (item.querySelector('.menu-item-icon')) return;

      // Walk child nodes to find the raw text node — avoids pulling in SVG text
      let rawLabel = '';
      item.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          rawLabel += node.textContent;
        }
      });
      rawLabel = rawLabel.trim().toLowerCase();

      if (!rawLabel) return;

      const iconUrl = MENU_ICONS[rawLabel];
      if (!iconUrl) return;

      const img     = document.createElement('img');
      img.src       = iconUrl;
      img.alt       = '';
      img.className = 'menu-item-icon';
      img.width     = MENU_ICON_SIZE;
      img.height    = MENU_ICON_SIZE;
      img.onerror   = function() { this.style.display = 'none'; };
      item.prepend(img);
    });
  }

  // Run after DOM ready
  document.addEventListener('DOMContentLoaded', injectMenuIcons);

  // Re-run when the hamburger details element opens (Dawn toggles this)
  document.addEventListener('toggle', injectMenuIcons, true);

  // Fallback: also watch for any drawer DOM changes (sub-menu opens etc)
  document.addEventListener('DOMContentLoaded', () => {
    const obs = new MutationObserver(injectMenuIcons);
    obs.observe(document.body, { childList: true, subtree: true });
    // Disconnect after 10s to avoid unnecessary overhead
    setTimeout(() => obs.disconnect(), 10000);
  });

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
